import React from "react";
//#region types
import { CommonEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { PopperFormProps } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { DialogTitle, Grid, DialogContent } from "@mui/material";
import { FormValidity, LighterTitle } from "components/common";
import { ErrorBoundary } from "components/error";
import DialogFooter from "../dialogs/dialogFooter";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const PopperForm: React.FC<PopperFormProps> = (props) => {
  const innerRef = React.useRef<FormHandles>(null);

  const childElement = React.Children.only(props.children);

  const submitFormContent = () => {
    return innerRef.current?.submit ? innerRef.current.submit() : Promise.resolve();
  };

  return (
    <FormValidity
      render={(isValid, onValidityChange) => (
        <Grid container className={cssExports.popperForm}>
          <Grid container className={cssExports.popperFormPaper} direction="column">
            <ErrorBoundary subComponentType={CommonEnums.SubComponentType.Dialog}>
              <DialogTitle id="dialog-title" className={cssExports.dialogHeader}>
                <LighterTitle title={props.title} subTitle={props.subTitle} />
              </DialogTitle>
              <ErrorBoundary subComponentType={CommonEnums.SubComponentType.Dialog}>
                <DialogContent className={cssExports.dialogContent}>
                  {React.cloneElement(childElement, {
                    ref: innerRef,
                    onFormValidationChange: onValidityChange,
                  })}
                </DialogContent>
                <DialogFooter
                  {...props}
                  isValid={isValid}
                  submitFormContent={submitFormContent}
                  closeView={props.closePopper}
                  onClose={props.closePopper}
                />
              </ErrorBoundary>
            </ErrorBoundary>
          </Grid>
        </Grid>
      )}
    />
  );
};

export default PopperForm;
